module.exports = __webpack_public_path__ + "img/strelkin.960a4147.jpg";